<template>
  <TsSection class="md:mt-6 mt-4">
    <TsTypography
      v-if="props.searchQuery && props.searchQuery.length > 0"
      append-class="mb-4 text-center"
      weight="normal"
      as="h1"
    >
      Getting results for "<strong>{{ searchQuery }}</strong
      >"
    </TsTypography>
    <TsTypography v-else append-class="mb-4 " weight="normal" as="h2">
      Search something interesting today!
    </TsTypography>
    <div class="flex items-center justify-center">
      <div class="loading-spinner-large"></div>
    </div>
  </TsSection>
</template>
<script setup lang="ts">

type Props = {
  searchQuery?: string;
};

const props = withDefaults(defineProps<Props>(), {});
const route = useRoute();
onMounted(() => {

    if( props.searchQuery === undefined || props.searchQuery?.length <= 0) {

  }
})

useHead({
  title: "Toolstation | Search",
  meta: [{ name: "description", content: "search result" }],
});

const { isMobile } = useDevice();
</script>

